import { render } from "./RegisterStep3.vue?vue&type=template&id=6b89c5da&scoped=true"
import script from "./RegisterStep3.vue?vue&type=script&lang=js"
export * from "./RegisterStep3.vue?vue&type=script&lang=js"

import "./RegisterStep3.vue?vue&type=style&index=0&id=6b89c5da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b89c5da"]])

export default __exports__